export const teamMember1 = {
  photo: require("../../images/photos/sonia.jpg"),
  alt: "Sonia Comin",
  teamName: "Sonia Comin",
  teamRole: "Project Manager",
};
export const teamMember2 = {
  photo: require("../../images/photos/majura.jpg"),
  alt: "Majura Siva",
  teamName: "Majura Siva",
  teamRole: "Marketing Director",
};
export const teamMember3 = {
  photo: require("../../images/photos/tanjiro.jpg"),
  alt: "Mouhcine Sennaoui",
  teamName: "Mouhcine Sennaoui",
  teamRole: "Flutter Developer ",
};
export const teamMember4 = {
  photo: require("../../images/photos/fabrice1.jpg"),
  alt: "Fabrice Tapia",
  teamName: "Fabrice Tapia",
  teamRole: "Flutter Developer & Project Manager",
};
export const teamMember5 = {
  photo: require("../../images/photos/prashanth.jpg"),
  alt: "Prashanth",
  teamName: "Prashanth Thiaga",
  teamRole: "Founder, CEO & Web Developer",
};
export const Donator4 = {
  photo: require("../../images/photos/sorupan.jpg"),
  alt: "Sorupan Raja",
  teamName: "Sorupan Raja",
  teamRole: " Donated xxxx€",
};
export const Donator2 = {
  photo: require("../../images/photos/majura.jpg"),
  alt: "Majura Siva",
  teamName: "Majura Siva",
  teamRole: "Donated xxxx€",
};
export const Donator3 = {
  photo: require("../../images/photos/anoji.jpg"),
  alt: "Pathma",
  teamName: "Pathma Sabeson",
  teamRole: "Donated xxxx€",
};
export const Donator1 = {
  photo: require("../../images/photos/galena.jpg"),
  alt: "Galena",
  teamName: "Galena Bala",
  teamRole: "Donated xxxx€",
};
export const Donator5 = {
  photo: require("../../images/photos/suren.jpg"),
  alt: "Ruban Raja",
  teamName: "Ruban Raja",
  teamRole: "Donated xxxx€",
};
export const Donator6 = {
  photo: require("../../images/photos/kanan.jpg"),
  alt: "Kanan",
  teamName: "Kanan Raja",
  teamRole: "Donated xxx€",
};
